import styled from 'styled-components';
import { LoadMoreButton } from 'styles/Table.styled';
import { SectionWrapper } from 'styles/Typography.styled';

export const Wrapper = styled(SectionWrapper)`
    width: 100%;
    align-items: center;
    flex-direction: column;
    padding: 0 16px;
`;

export const LoadMoreStyled = styled(LoadMoreButton)`
    margin: 0 32px;
    width: 100%;
    width: -moz-available;
    width: -webkit-fill-available;
`;
